import { DataPoint } from 'Interfaces/DataPoint';
import { ListItem, questionTypes } from 'Interfaces/Forms/QuestionInterface';
import FormUtils from 'views/SingleInstance/utils/FormUtils';

export const organizeMonthData = (data: DataPoint[]) => {
  const organizedData: DataPoint[][] = [];
  for (const dp of data) {
    const created = new Date(dp['created']);
    const month = created.getMonth();
    organizedData[month] = organizedData[month] || [];
    organizedData[month].push(dp);
  }
  return organizedData;
};

export const getStatusCounts = (data: DataPoint[], status: ListItem[]) => {
  const statusCounts = [];
  const ids = status.map(s => s.id);
  data.forEach(d => {
    if (d['kanbanStatus']) {
      const index = ids.indexOf(d['kanbanStatus']);
      if (index > -1) {
        statusCounts[index] = statusCounts[index] || 0;
        statusCounts[index]++;
      }
    }
  });
  return statusCounts;
};


export const organizeStatusData = (data: DataPoint[], status: ListItem[], statusKey: string = 'kanbanStatus') => {
  const statusData: DataPoint[][] = [];
  const ids = status.map((s, index) => {
    statusData[index] = [];
    return s.id;
  });
  data.forEach(d => {
    if (d[statusKey]) {
      const index = ids.indexOf(d[statusKey]);
      statusData[index] = statusData[index] || [];
      statusData[index].push(d);
    }
  });
  return statusData;
};

export const initializeKanban = (formUtils: FormUtils) => {
  const DEFAULT_FIELDS = ['created', 'id', 'kanbanStatus', 'Name', 'dueDate', 'files'];
  const statusQuestion = formUtils.getQuestion('kanbanStatus');
  let priority = '';
  if (formUtils.getModel().ncrType && formUtils.getModel().ncrType === 'basic') {
    priority = 'ncrb_severity';
  } else if (formUtils.getModel().kanban) {
    priority = 'kanbanPriority';
  }
  if (statusQuestion) {
    const listItems = statusQuestion.listItems?.listItem;
    const qns = formUtils.getQuestions();
    const keys = Object.keys(qns);
    const qnIds: string[] = [...DEFAULT_FIELDS];
    const ef: string[] = [];
    const filterQ: string[] = [];
    for (const key of keys) {
      const qn = qns[key];
      if (qn.showInKanbanCard && !DEFAULT_FIELDS.includes(key) && key !== priority) {
        qnIds.push(key);
        ef.push(key);
      }
      if (
        qn.validationlist && qn.validatefield || qn.type === questionTypes.LOOKUP_VALUES_QUESTION && qn.lookupValue
      ) {
        filterQ.push(key);
      }
    }
    if (priority) {
      qnIds.push(priority);
    }

    return { severityId: priority , fields: qnIds, extraFields: ef, filterQuestions: filterQ, statuses: listItems };
  }
  return null;
};
